import React from "react";
import "./ObjectiveScreen.css";
import { useEffect, useState } from "react";
import {
  Dec,
  auth_token,
  auth_token_name,
  segment_detail_url,
  segment_id_name
} from "../Webcontroller/Webcontroller";

import { motion } from "framer-motion";

const containerVariants = {
  hidden: {
    opacity: 0,
    transition: {
      staggerChildren: 0.5,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      mass: 0.4,
      damping: 8,
      staggerChildren: 0.5,
      when: "beforeChildren",
    },
  },
};

const childVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

const ObjectiveScreen = () => {
  const [trainData, setTrainData] = useState([]);
  
    useEffect(() => {
      const trainData = new FormData();
      trainData.append(auth_token_name, auth_token);
      trainData.append(segment_id_name, 22);
      trainData.append(Dec, 0);
  
      fetch(segment_detail_url, {
        method: "POST",
        body: trainData,
      })
        .then((res) => res.json())
        .then((data) => {
          setTrainData(data.data);
        })
        .catch((error) => { });
    }, []);

  return (
  
    <div className="bg-object-div" id="objective">
          <div className="container  pb-5 ">
    
            {trainData.length > 0 ? (
              <motion.div
          className="bg-white  bg-object-card"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
                <div className=" justify-content-start  pb-5">
                  <h3 className=" bg-object-h3">Objective</h3>
    
                  {/* <div className=" justify-content-start  pb-5"> */}
                  {trainData.map((item, index) => (
                    <div
                      key={index}
                      className=""
                    >
                      {/* <p className="  pe-2">{index + 1}.</p> */}
                      <motion.div
                                            variants={childVariants}
                                            className="bg-objective-p para-1"
                                            dangerouslySetInnerHTML={{ __html: item.details }}
                                          />
                      {/* <motion.p variants={childVariants} className="bg-objective-p para-1">
                        {index + 1}. {item.details}
                      </motion.p> */}
                    </div>
    
    
                  ))}
                </div>
              </motion.div>
            ) : (
              <div className="d-flex justify-content-center loading-bg">
                <div className="loading-spinner"></div>
              </div>
            )}
          </div>
        </div>
  );
};

export default ObjectiveScreen;
